module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-cf-project-feedback-detail"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("反馈详情 " + _vm._s(_vm.state.index) + "/" + _vm._s(_vm.state.count))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading && _vm.state.is_pay_info) ? _c('lxm-row', {
    attrs: {
      "icon-class": 'lxm-row__img-icon lxm-row__img-icon--cf-money',
      "name": '支付金额'
    }
  }, [_vm._v("\n        " + _vm._s(_vm.amount) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading && _vm.state.is_pay_info) ? _c('lxm-row', {
    attrs: {
      "icon-class": 'lxm-row__img-icon lxm-row__img-icon--cf-status',
      "name": '支付状态'
    }
  }, [_c('span', {
    staticClass: "lxm-cf-project-feedback-detail__status"
  }, [(_vm.state.status.success) ? [_c('span', {
    staticClass: "lxm-cf-project-feedback-detail__status-success"
  }, [_c('img', {
    staticClass: "lxm-cf-project-feedback-detail__status-img lxm-cf-project-feedback-detail__status-img--success",
    attrs: {
      "src": require("../../images/main/cf/success.png")
    }
  }), _vm._v("\n              成功\n            ")])] : [_vm._v("\n            未成功\n          ")], _vm._v(" "), (_vm.state.status.channel) ? [(_vm.state.status.channel.indexOf('微信') >= 0) ? _c('img', {
    staticClass: "lxm-cf-project-feedback-detail__status-img lxm-cf-project-feedback-detail__status-img--weixin",
    attrs: {
      "src": require("../../images/main/cf/weixin.png")
    }
  }) : (_vm.state.status.channel.indexOf('支付宝') >= 0) ? _c('img', {
    staticClass: "lxm-cf-project-feedback-detail__status-img lxm-cf-project-feedback-detail__status-img--weixin",
    attrs: {
      "src": require("../../images/main/cf/alipay.png")
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.state.status.channel) + "\n          ")] : _vm._e()], 2)]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('div', [_vm._l((_vm.rows), function(row) {
    return [_c('lxm-form-row', {
      staticStyle: {
        "overflow-wrap": "anywhere"
      },
      attrs: {
        "row": row
      }
    })]
  })], 2) : _vm._e()])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71a07c22", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71a07c22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Activity/FeedbackDetail.vue
// module id = 866
// module chunks = 0